<div class="container content">
    <div>
        <button class="closeHeader" (click)="close()">
            <img src="./assets/images/close cross.svg">
        </button>
    </div>
    <div class="row">
        <div class="col-lg-12 col-sm-12 col-md-12 image">
            <img src="./assets/images/success.svg">
        </div>
    </div>
    <div class="row message">
        {{message}}
    </div>
</div>